import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Avatar from "./Avatar";
import VerifiedBadge from "./VerifiedBadge";

export default function LeftSidebar() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <aside data-testid="left-sidebar" className="bg-[#121212] border border-[#262626] rounded-sm overflow-hidden">
      <div className="relative">
        <div
          className="h-20 bg-cover bg-center"
          style={{
            backgroundImage: user.cover_url
              ? `url(${user.cover_url})`
              : `url(https://images.pexels.com/photos/28827841/pexels-photo-28827841.jpeg)`,
          }}
        />
        <div className="absolute left-4 -bottom-6">
          <Avatar url={user.avatar_url} name={user.name} size={56} />
        </div>
      </div>
      <div className="pt-9 pb-4 px-4 border-b border-[#262626]">
        <Link
          to={`/profile/${user.id}`}
          data-testid="sidebar-my-profile-link"
          className="font-semibold text-white text-sm hover:underline inline-flex items-center gap-1.5"
        >
          {user.name}
          <VerifiedBadge role={user.role} verified={user.verified} size={13} />
        </Link>
        <div className="text-xs text-[#a3a3a3] mt-0.5">
          {user.role && user.role !== "player"
            ? user.role.charAt(0).toUpperCase() + user.role.slice(1)
            : user.position || "Player"}
          {user.team ? ` · ${user.team}` : ""}
        </div>
      </div>
      <div className="grid grid-cols-2 divide-x divide-[#262626] text-center py-3">
        <div>
          <div data-testid="sidebar-followers-count" className="font-display text-lg text-white">{user.followers_count}</div>
          <div className="text-[10px] uppercase tracking-widest text-[#737373]">Followers</div>
        </div>
        <div>
          <div data-testid="sidebar-following-count" className="font-display text-lg text-white">{user.following_count}</div>
          <div className="text-[10px] uppercase tracking-widest text-[#737373]">Following</div>
        </div>
      </div>
    </aside>
  );
}
